import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEngagementResourcesIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.9001 4.22C18.7301 6.84 20.0001 2 20.0001 2C20.0001 2 18.8901 8.07 13.7901 10.55C12.7501 11.06 12.1001 11.33 12.1001 11.33L3.73008 7.25L12.1001 3.82C12.1001 3.82 11.9001 3.76 12.9001 4.22ZM11.1201 22L3.33008 17.78V9.07L11.1201 13.04V22ZM12.8801 22L20.6801 17.78V9.07L12.8801 13.04V22Z",
		fill: "currentColor"
	})
});
export default SvgEngagementResourcesIcon;
